module.exports = __webpack_public_path__ + "img/steps2.996f2d10.svg";